module.exports = __webpack_public_path__ + "img/icon_header_login.608f69c9.svg";